import api from "../lib/apiClient";
export const getGiveaway = () => api.get("/giveaway").then((r) => r.data);
export const getGiveawayStatus = () => api.get("/giveaway/status").then((r) => r.data);
export const enterGiveaway = () => api.post("/giveaway/enter").then((r) => r.data);
export const adminUpdateGiveaway = (data) => api.patch("/admin/giveaway", data).then((r) => r.data);
